import { render } from "./IntroPage.vue?vue&type=template&id=2d3d6907&scoped=true"
import script from "./IntroPage.vue?vue&type=script&lang=js"
export * from "./IntroPage.vue?vue&type=script&lang=js"

import "./IntroPage.vue?vue&type=style&index=0&id=2d3d6907&lang=scss&scoped=true"

import exportComponent from "/home/forge/vienaiespeja.on-forge.com/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d3d6907"]])

export default __exports__